<template>
  <div>
    <naj-box :title="local.internationalBodies.title">
      <v-row>
        <v-col
          cols="12"
          lg="3"
        >
          <naj-input
            :type-id="formFieldType.text"
            :label="local.internationalBodies.name"
            :value.sync="formModel.name"
            validates="required|arabic|isIdAllowed"
            :disabled="isViewMode"
          ></naj-input>
        </v-col>
      </v-row>
    </naj-box>

    <naj-address
      :title="local.titleHeader.addressHumanitarian"
      :form-model="formModel.placeAddress"
      :required="required"
      :is-view-mode="isViewMode"
    ></naj-address>
  </div>
</template>

<script>
export default {
  inject: ['$validator'],
  props: ['formModel', 'required', 'isViewMode'],
};
</script>
